import { onBeforeUnmount, onMounted, ref, unref } from 'vue';

function useDropdownStyle({ dropdownRef, selectRef, isFillWithSelect }) {
  /**
   * - 場景 1: props.isFillWithSelect 成立下，初始時取得 Select Width 並固定 Dropdown 寬度
   * - 場景 2: Dropdown 在 `width: max-content` 下，至少要 120px，不超過 600px
   * 		- 初始時，會固定寬度，之後不會隨意變動
   */
  const dropdownStyles = ref({});
  const resizeObserver = ref(null);

  function keepDropdownWidth() {
    const dropdown = dropdownRef.value?.$el;
    if (dropdown) {
      dropdownStyles.value = { width: `${dropdown.offsetWidth}px` };
    }
  }

  onMounted(() => {
    const select = selectRef.value?.$el;
    if (select?.offsetWidth && isFillWithSelect) {
      dropdownStyles.value = { width: `${select.offsetWidth}px` };
      return;
    }
    // 情境：select 元素不可見時 (display: none;)
    resizeObserver.value = new ResizeObserver((entries) => {
      for (const entry of entries) {
        // 判斷父元素是否處於 display: none 的狀態
        if (entry.contentRect.width) {
          if (isFillWithSelect && select) {
            dropdownStyles.value = { width: `${select.offsetWidth}px` };
            resizeObserver.value.disconnect();
          }
        }
      }
    });
    resizeObserver.value.observe(select);
  });

  onBeforeUnmount(() => {
    const _resizeObserver = unref(resizeObserver);
    _resizeObserver && _resizeObserver.disconnect();
  });

  return {
    keepDropdownWidth,
    dropdownStyles,
  };
}

export { useDropdownStyle };
